import React from 'react';

import NewPost from './NewPost';
import Loading from './Loading';

import { fadeIn, setMeta } from '../helpers';

class NewCollection extends React.Component {

	componentDidMount() {
		fadeIn();
		setMeta('description');
		setMeta('image');
		setMeta('title', 'New - Chermayeff & Geismar & Haviv');
	}

	componentDidUpdate(prevProps, prevState) {
		fadeIn();
	}

	render() {

		if(this.props.posts.length === 0) {
			return(<Loading />);
		} else {
			document.querySelector('main').classList.remove('main--loading');

			return (
				<div className="newCollection js-fade__slow js-fadeMeIn">
						{
							Object.keys(this.props.posts)
							.map(i => <NewPost key={this.props.posts[i].title} 
																			 details={this.props.posts[i]}
																			 />)
						}
				</div>
			)
		}
	} // end render()
} // end class NewCollection extends React.Component

export default NewCollection;


/** WEBPACK FOOTER **
 ** ./src/components/NewCollection.js
 **/